import { z } from "zod/v3";

export const createTaskSchema = z.object({
  title: z
    .string()
    .min(1, "Título é obrigatório")
    .min(3, "Título deve ter pelo menos 3 caracteres")
    .max(100, "Título deve ter no máximo 100 caracteres"),
  userId: z
    .number()
    .min(1, "ID do usuário é obrigatório")
    .max(10, "ID do usuário deve ser entre 1 e 10"),
  completed: z.boolean(),
});

export type CreateTaskFormData = z.infer<typeof createTaskSchema>;
